<template>
    <SiteContentPageWrapper :model="model" />
</template>

<script>
import SiteContentPageWrapper from '@/components/Pages/SiteContentPageWrapper';

export default {
    name: 'PrivacyPolicy',
    components: {
        SiteContentPageWrapper,
    },
    async asyncData({ $axios, error, i18n }) {
        let model = null;

        await $axios
            .$get('/content/by-slug/privacy-policy')
            .then((res) => {
                if (res.success === 1) {
                    model = res.data;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return error({ statusCode: 404, message: i18n.t('error.page_not_found.title') });
        }

        return { model };
    },
    head() {
        return {
            title: this.$getOgTitle(this.$t('privacy_policy.title')),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('privacy_policy.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('privacy_policy.title')),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
